<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <image-uploader :uploadedImg="config[field.key]" :defaultImg="field.defaultImg"  @uploaded="handleUpload"
                            class="small-image" :tip="field.memo"></image-uploader>
            <div v-if="field.tip">{{field.tip}}</div>
        </el-form-item>
    </div>
</template>

<script>

  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-img',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {}
    },

    components: {
      ImageUploader
    },

    mounted() {

    },

    methods: {
      handleUpload(src, index) {
        this.$set(this.config, this.field.key, src);
      },
    }
  }

</script>
